import { ElasticCache, ExternalItem } from "@westpierstudio/luma/utils/elastic-cache";
import { GameServices } from "game/GameServices";
import { Spine } from "pixi-spine";
import { Container } from "pixi.js";
import { resetSpine } from "utils/Misc";
import { CrossbowBonusSpec } from "./CrossbowBonus";

export type MultiplierCache = { [key: number]: ElasticCache<Spine> };

export class CrossbowMultipliers extends Container {
    protected cache: MultiplierCache;
    protected spec: CrossbowBonusSpec;

    activeSpines: [number, ExternalItem<Spine>][] = [];

    readonly MIN_MULTIPLIER = 2;

    constructor(protected readonly services: GameServices) {
        super();
        this.spec = services.resources.getSpec(`crossbowbonus`);
        this.cache = this.setupCache();
    }

    private setupCache(): MultiplierCache {

        const { factory, resources } = this.services;

        const cache: MultiplierCache = {};

        for (const [index, spec] of this.spec.multiplierSpines.entries()) {
            const key = index + this.MIN_MULTIPLIER;
            cache[key] = new ElasticCache<Spine>(
                () => {
                    const spine = factory.createSpine(spec, this);
                    spine.visible = false;
                    return spine;
                },
                () => { }, () => { }, 1);
        }

        return cache;
    }

    get(multiplierNumber: number) {
        const spine = this.cache[multiplierNumber].get();
        spine.reference.visible = true;
        this.activeSpines.push([multiplierNumber, spine]);
        return spine;
    }

    resetMultipliers() {
        for (const [value, spine] of this.activeSpines) {
            spine.reference.visible = false;
            resetSpine(spine.reference);
            this.cache[value].free(spine);
        }
        this.activeSpines = [];
    }
}
